import {Component, Input, OnChanges, OnInit, SimpleChanges, TemplateRef, ViewChild} from '@angular/core';
import {forkJoin} from 'rxjs';
import {FacilityService} from '../../services/facility.service';
import * as moment from 'moment';
import {
  IFacilityHoliday,
  IFacilityInfo,
  IFacilityMerchandise,
  IFeatures,
  IInternetSettings
} from '../../Shared/interface';
import {GeneralService} from '../../services/general.service';
import {UserSessionService} from '../../services/usersession.service';
import { BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-store-info',
  templateUrl: './store-info.component.html',
  styleUrls: ['./store-info.component.scss']
})
export class StoreInfoComponent implements OnInit, OnChanges {
  @ViewChild('template1', { static: true }) storeinfoPopup: TemplateRef<any>;
  @Input() localLocationObj = {Id: 0, Name: ''};
  @Input() storeInfoFacId: number = 0;
  @Input() isFromUnitInfo: boolean = false;
  @Input() isFromQuickprospect: boolean = false;

  facilityHours: any = [];
  facilityHolidays: any;
  facilityFeatures: IFeatures;
  facilityMerchandise: any;
  masterfacilityMerchandise: any;
  searchValue: boolean = false;
  searchmerchandisepack: any;
  facilityInternetSettings: IInternetSettings;
  facilityInfoDetails: IFacilityInfo;
  facilityAminitiesList: any;
  featuresAminities: any = [];
  featuresMisc: any;
  photoFilePath: string;
  facilityId: any;
  mapTo: string;
  mapFrom: string;
  modalRef: any;

  callCenterSelectedUnitStore = 0;
  previousFacilityId: number = 0;

  constructor(
    private storeService: FacilityService,
    private generalService: GeneralService,
    private userSessionService: UserSessionService,
    private modalService: BsModalService,
  ) { }

  ngOnInit() {
    if (this.userSessionService.userSessionData) {
      if (this.storeInfoFacId != 0) {
        this.getHours(this.storeInfoFacId);
      }
    }

    this.userSessionService.unitChangeEmitter.subscribe((facilityId) => {
     if (facilityId && this.userSessionService.isCallcenterAgent) {
       this.callCenterSelectedUnitStore = facilityId;
     }
   });
  }

  ngOnChanges(changes: SimpleChanges): void {
    var change = changes['storeInfoFacId'];
    if (change) {
    }  
  }

  storetoggClass(Cls) {
    if (this.userSessionService.isCallcenterAgent) {
      if (this.callCenterSelectedUnitStore) {
        this.storeInfoFacId = this.callCenterSelectedUnitStore;
      }
      if (this.previousFacilityId != this.storeInfoFacId) {
        this.previousFacilityId = this.storeInfoFacId
        this.GetStoreDetails(this.storeInfoFacId);
      }
    } else {
      this.storeInfoFacId = this.storeInfoFacId;
      if (!this.facilityInfoDetails || (this.facilityInfoDetails && this.facilityInfoDetails.Id != this.storeInfoFacId)) {
        this.GetStoreDetails(this.storeInfoFacId);
      }
    }
    (document.querySelector('.head_store_info') as HTMLElement).classList.toggle(Cls);

  }

  convertMoment(time) {
    if (time !== null) {
      return moment(time, ["HH:mm:ss"]).format("hh:mm A");
    }
  }

  getHours(facId) {
    if (this.userSessionService.lovList && this.userSessionService.lovList.length) {
      this.storeService.getFacilityHoursForOp(facId).subscribe((facilityHours) => {
        let weekList = this.userSessionService.getLovListForType(33);
        this.setGetHoursData(facilityHours, weekList);
      });
    } else {
      forkJoin(this.storeService.getFacilityHoursForOp(facId), this.generalService.getAllListOfValues())
        .subscribe(([facilityHours, listOfValues]) => {
          this.userSessionService.lovList = listOfValues;
          let weekList = this.userSessionService.getLovListForType(33);
          this.setGetHoursData(facilityHours, weekList);
        });
    }
  }

  setGetHoursData(facilityHours, weekList) {
    if (facilityHours.StoreHours.length) {
      facilityHours.StoreHours.map((ele) => {
        if (weekList.find(o => o.Id === ele.WeekDay)) {
          ele['DayName'] = weekList.find(o => o.Id === ele.WeekDay).Name;
        }
        ele.StartTime = this.convertMoment(ele.StartTime);
        ele.EndTime = this.convertMoment(ele.EndTime);
        ele.GateStartTime = this.convertMoment(ele.GateStartTime);
        ele.GateEndTime = this.convertMoment(ele.GateEndTime);
      });
      this.facilityHours = facilityHours.StoreHours;
    }
  }

  GetStoreDetails(facId) {
    this.getFacilityFeatures(facId);
    this.storeService.getFacilityInfoForOp(facId).subscribe((response: IFacilityInfo) => {
      this.facilityInfoDetails = response;
      this.mapTo = response.Address + ',' + response.City + ',' + response.Zip;
    });
  }

  // getStoreHours(facId) {
  //   this.storeService.getFacilityHours(facId).subscribe((response: IFacilityHours) => {
  //     this.facilityHours = response.StoreHours;
  //     console.log('Facility Hours', this.facilityHours);
  //   });
  // }
  getHolidays(facId) {
    this.storeService.getActiveHolidaysForOp(facId).subscribe((response: IFacilityHoliday) => {
      this.facilityHolidays = response.Holidays;
      // console.log('facility Holidays', this.facilityHolidays);
    });
  }

  getFacilityFeatures(facId) {
    this.storeService.getFacilityFeatures(facId).subscribe((response: IFeatures) => {
      this.facilityFeatures = response;
      if(response && response.PhotoFilePath){
        this.photoFilePath = response.PhotoFilePath;
        } else {
          this.photoFilePath = `../assets/images/store.PNG`;
        }
    });
  }

  getFacilityMerchandise(facId) {
    this.storeService.getActiveMerchandiseForOp(facId).subscribe((response: IFacilityMerchandise) => {
      this.facilityMerchandise = response.MerchandiseList;
      this.masterfacilityMerchandise = this.facilityMerchandise;
    });
  }

  getFacilityInternetSettings(facId) {
    this.storeService.GetFacilityInternetSettingsForOp(facId).subscribe((response: IInternetSettings) => {
      this.facilityInternetSettings = response;
      //  console.log('facility InternetSettings', this.facilityInternetSettings);
    });
  }
  getFormattedSiteInformation(info?) {
    if (!info) { return '' }
    return info.replace(/\n/g, '<br>') || '';
  }

  getAmminites(facId) {
    this.storeService.getFacilityAminities(facId).subscribe((response: any) => {
      this.facilityAminitiesList = response;
      if (response.length) {
        this.featuresAminities = response.filter((ele) => ele.Miscellaneous === false);
        this.featuresMisc = response.filter((ele) => ele.Miscellaneous === true);       
      }
    });
  }

  goToMap() {
    let url = `https://www.google.com/maps/dir/?api=1&origin=${encodeURIComponent(this.mapFrom)}&destination=${encodeURIComponent(this.mapTo)}`;
    window.open(url, "_blank");
  }

  redirectToUrl() {
    if (this.facilityInternetSettings != null) {
      let url = this.facilityInternetSettings.WebsiteUrl.toLowerCase();
      if (url.includes('http:') || url.includes('https:')) {
        url = this.facilityInternetSettings.WebsiteUrl;
      } else {
        url = 'http://' + this.facilityInternetSettings.WebsiteUrl;
      }
      window.open(url, "_blank");
    }
  }

  onMerchandiseClick() {
    if (this.storeInfoFacId != 0) {
      this.getFacilityMerchandise(this.storeInfoFacId);
    }
  }

  onClickOfTabs(TabName) {
    if(this.storeInfoFacId !== 0) {
      if(TabName == 'storeinfo' && (!this.facilityInfoDetails)) {
        this.GetStoreDetails(this.storeInfoFacId);
      } else if(TabName == 'hours' && (!this.facilityHours || !this.facilityHours.length)) {
        this.getHours(this.storeInfoFacId);
      }else if(TabName == 'holidays' && (!this.facilityHolidays || !this.facilityHolidays.length)) {
        this.getHolidays(this.storeInfoFacId);
      } else if(TabName == 'features' && (!this.featuresAminities || !this.featuresMisc)) {
          this.getAmminites(this.storeInfoFacId);
      } else if(TabName == 'merchandise' && (!this.facilityMerchandise || !this.facilityMerchandise.length)) {
        this.getFacilityMerchandise(this.storeInfoFacId);
        this.searchmerchandisepack = '';
        this.searchValue = false;
      } else if(TabName == 'internet' && (!this.facilityInternetSettings || !this.facilityInfoDetails)) {
        this.getFacilityInternetSettings(this.storeInfoFacId);
        this.GetStoreDetails(this.storeInfoFacId);
      } else if(TabName == 'maps' && (!this.mapTo)) {
        this.GetStoreDetails(this.storeInfoFacId);
      } else if(TabName == 'Siteinfo' && (!this.facilityInternetSettings)) {
        this.getFacilityInternetSettings(this.storeInfoFacId);
      } else if(TabName == 'kiosk' && (!this.facilityInternetSettings)) {
        this.getFacilityInternetSettings(this.storeInfoFacId);
      }
    }
  }

  openModal() {
    if (this.storeInfoFacId == 0) {
      return
    }
    if (this.previousFacilityId != this.storeInfoFacId && this.storeInfoFacId != 0) {
      this.GetStoreDetails(this.storeInfoFacId);
      this.previousFacilityId = this.storeInfoFacId
    }
    this.modalRef = this.modalService.show(this.storeinfoPopup, { class: "modal-dialog-centered modal-xl-921", backdrop: 'static', keyboard: false });
  }

  onsearchMerch(e) {
    if(e) {
      this.searchValue = true;
    } else {
      this.searchValue = false;
    }
      this.facilityMerchandise  = this.masterfacilityMerchandise?.filter( ele => {
        if(ele.Name.toLowerCase().includes(e.toLowerCase())){
          return ele;
        }
    });
  }

  resetfilter() {
    this.searchmerchandisepack = '';
    this.onsearchMerch('');
  }

closeModal() {
  this.modalRef.hide();
}

}
